import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import {
    IAgreement,
    ICreateAgreement,
    IEditAgreementViewModel,
    IUpdatePhotographerAgreement
} from './Entities';
import IPhotographer from '../photographers/IPhotographer';

class AgreementsApi {
    static listAgreements(): any {
        return new Promise<any>((resolve: any, reject: any) => {
            new Api()
                .get('/views/agreements')
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    static newAgreement(): any {
        return new Promise<any>((resolve: any, reject: any) => {
            new Api()
                .get('/views/agreements/new')
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    static createAgreement(agreement: ICreateAgreement): any {
        return new Promise<any>((resolve: any, reject: any) => {
            new Api()
                .post('/views/agreements', agreement)
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    static editAgreement(id: number) {
        return new Api().get(`/views/agreements/${id}/edit`);
    }

    static updateAgreement(agreement: IEditAgreementViewModel) {
        return new Promise<any>((resolve: any, reject: any) => {
            new Api()
                .put(`/views/agreements/${agreement.id}`, agreement)
                .then(resolve)
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    static deleteAgreement(id: number): any {
        return new Api().delete(`/views/agreements/${id}`);
    }

    static checkDeleteAgreement(id: number): any {
        return new Api().get(`/views/agreements/${id}/check`);
    }

    static updatePhotographerAgreement(photographers: IUpdatePhotographerAgreement[]): any {
        return new Api().put(`/views/photographers/agreement`, {
            photographers
        });
    }
}

export default AgreementsApi;
